export default __webpack_public_path__ + "static/media/twitterButton.66f2dabf.png";